<template>
  <div class="animated fadeIn vld-parent custom-100" >
    <b-row>
      <b-col sm="12">
        <planning-list-searchbar ref="searchBar"
                   :selected-date="currentDate"
                   :on-search="queryData"
        ></planning-list-searchbar>
      </b-col>
    </b-row>
    <b-row class="custom-flex-1">
      <b-col sm="12">
        <planning-list-table ref="planning_list_table"
                        :table-data="data"
                        @finish-task="onFinishTask"
        ></planning-list-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {Redirect_500, Redirect_Login, Server_URL} from "@/shared/utils";
import {DateTime as LuxonDateTime} from "luxon";
import {parseTimestamp} from "@/shared/dates";

import PlanningListTable from "@/views/planning_lists/PlanningListTable.vue";
import PlanningListSearchbar from "@/views/planning_lists/PlanningListSearchbar.vue";


export default {
  name: "PlanningLists",
  components: {
    PlanningListSearchbar,
    PlanningListTable},
  data() {
    return {
      // SearchbarProps
      data: [],
      currentPage: 1,
      currentDate: null,
      aufgabe: null,
    }
  },

  mounted() {
    this.currentDate = LuxonDateTime.local().toISO();
    this.queryData("O",  LuxonDateTime.local().toISO(), "M", "");
  },
  methods: {
    onFinishTask(aufgabe) {
      this.aufgabe = aufgabe;
      this.showLoader();
      this.$http.post(
          Server_URL + '/auftragsbuch/data/lists/finish/' + this.aufgabe.id
      ).then(this.responseOkTrap, this.responseError)
    },
    responseOkTrap(response) {
      this.hideLoader();
      if (response.status === 200 ) {
        for (let i = 0; i < this.data.length; i++) {
          if (this.data[i].id === this.aufgabe.id) {
            this.data[i].complete = 10;
            this.data[i].completed = "something";
            let status = this.$refs.searchBar.getCurrentType();
            if (status === 'O') {
              this.data.splice(i, 1);
              break;
            }
          }
        }
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    responseOkGet(response) {
      if (response.status === 200 && response.body.status === "ok") {
        this.currentDate = LuxonDateTime.local().toISO();

        this.queryData("O",  LuxonDateTime.local().toISO(), "M", "");
      } else {
        window.location = Redirect_500;
      }
    },
    responseOkFetch(response) {
      this.hideLoader();
      this.$refs.planning_list_table.currentPage = 1;
      this.$refs.searchBar.onFirstSearch();
      if (response.status === 200 ) {
        let data = response.body;
        this.data = data;
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
    queryData(status, currentDate, dateType, searchText) {
      this.showLoader();
      let d = parseTimestamp(new Date(Date.parse(currentDate)), "DD.MM.YYYY")
      d = encodeURIComponent(d)
      this.$http.get(
          Server_URL+'/auftragsbuch/data/lists/fetch'+
          "?status_type="+status+
          "&search_text="+searchText+
          "&selected_date_type="+dateType+
          "&selected_start_date="+d
      ).then(this.responseOkFetch, this.responseError)
    },

    showLoader() {
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
  },
}
</script>

<style scoped>
::v-deep .tab-content {
  display: none !important;
}

.bauhof-border {
  border-left: 5px solid #FBFBFB;
  border-right: 5px solid #FBFBFB;
}

</style>
<style>
.toast-pre-wrap {
  white-space: pre-wrap;
}
</style>
